import React, { useEffect, useState } from 'react'
import { StyleSheet, Text, View } from 'react-native'
import * as Updates from 'expo-updates'
import { colors } from '@lib/colors'
import useSentry from '@hooks/useSentry'
import Show from '@components/Show'
import Button from '@components/Button'

export default function () {
  const { captureException } = useSentry()
  const [promptUserToReload, setPrompUserToReload] = useState(false)
  const [userWantsToReload, setUserWantsToReload] = useState<null | boolean>(
    null,
  )

  useEffect(() => {
    if (__DEV__) return

    const interval = setInterval(() => {
      try {
        Updates.checkForUpdateAsync().then(update => {
          if (update.isAvailable) {
            Updates.fetchUpdateAsync().then(() => {
              setPrompUserToReload(true)
            })
          }
        })
      } catch (error: unknown) {
        captureException(error)
      }
    }, 60000)

    const subscription = Updates.addListener(event => {
      if (event.type === Updates.UpdateEventType.UPDATE_AVAILABLE) {
        setPrompUserToReload(true)
      }
    })

    return () => {
      subscription.remove()
      if (interval) clearInterval(interval)
    }
  }, [])

  useEffect(() => {
    if (userWantsToReload) {
      Updates.reloadAsync()
      return
    }

    setUserWantsToReload(null)
    setPrompUserToReload(false)
  }, [userWantsToReload])

  return (
    <Show when={promptUserToReload}>
      <View style={styles.container}>
        <Text style={styles.text}>
          A new app version is available. Would you like to reload the app to
          see the updates?
        </Text>
        <View style={styles.buttonsWrapper}>
          <Button
            label='Update & Reload'
            buttonStyles={{ backgroundColor: colors.blue[400], ...styles.button }}
            onPress={() => setUserWantsToReload(true)}
          />
          <Button
            label='Not now'
            buttonStyles={{ backgroundColor: colors.gray[300], ...styles.button }}
            onPress={() => setUserWantsToReload(false)}
          />
        </View>
      </View>
    </Show>
  )
}

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    top: 0,
    width: '100%',
    padding: 20,
    paddingTop: 60,
    backgroundColor: colors.white,
    zIndex: 9999,
    shadowColor: colors.gray[500],
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.5,
    shadowRadius: 5,
  },
  text: {
    fontSize: 16,
    marginBottom: 15,
    textAlign: 'center',
  },
  button: {
    marginLeft: 5,
    marginRight: 5,
  },
  buttonsWrapper: {
    flexDirection: 'row',
    justifyContent: 'center',
  },
})
